import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { XIcon, CheckIcon } from "lucide-react";
import { costComparison } from "../data/salesCopy";
import { SectionHeader } from "./SectionHeader";
export function CostComparison() {
  const [mode, setMode] = useState<"without" | "with">("without");
  const isWith = mode === "with";
  return <section className="mx-auto max-w-5xl px-5 py-9 md:py-16" data-id="element-46" data-mp="2ym1udh5wii6q">
      <SectionHeader eyebrow={costComparison.eyebrow} title={costComparison.title} tone="coral" data-id="element-47" data-mp="2ylie04vwg1ut" />

      {/* Mobile: interactive toggle */}
      <div className="mt-5 md:hidden" data-id="element-48" data-mp="2pldesi0v09rq">
        <div role="tablist" className="relative grid grid-cols-2 rounded-xl bg-card p-1 ring-1 ring-line" data-id="element-49" data-mp="2pkan47vpq3ar">
          <motion.span className={`absolute inset-y-1 w-[calc(50%-4px)] rounded-lg ${isWith ? "bg-chalk" : "bg-coral"}`} animate={{
          x: isWith ? "100%" : "0%"
        }} transition={{
          duration: 0.22,
          ease: [0.23, 1, 0.32, 1]
        }} style={{
          left: 4
        }} data-id="element-50" data-mp="2klhbkkzzkmd8" />
          {(["without", "with"] as const).map(m => <button key={m} type="button" role="tab" aria-selected={mode === m} onClick={() => setMode(m)} className={`relative z-10 py-2 text-sm font-bold transition-colors duration-150 ease-out ${mode === m ? "text-white" : "text-muted"}`} data-id="element-51" data-mp="2pc48ik3it7zk">
              {m === "with" ? costComparison.with : costComparison.without}
            </button>)}
        </div>

        <AnimatePresence mode="wait" initial={false} data-id="element-52" data-mp="26etepf0nr6ri">
          <motion.ul key={mode} initial={{
          opacity: 0,
          y: 6
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -6
        }} transition={{
          duration: 0.18,
          ease: [0.23, 1, 0.32, 1]
        }} className={`mt-3 divide-y rounded-xl p-1 ${isWith ? "divide-white/10 bg-chalk text-white" : "divide-line bg-coral-soft"}`} data-id="element-53" data-mp="1smwojgijv6xr">
            {costComparison.rows.map(([bad, good]) => <li key={bad} className="flex gap-2.5 px-3 py-2.5 text-[13px] leading-snug" data-id="element-54" data-mp="14ki76ibulnvv">
                {isWith ? <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-pencil" aria-hidden="true" data-id="element-55" data-mp="uslxsb4babcc" /> : <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-coral" aria-hidden="true" data-id="element-56" data-mp="pu15cxvawvyg" />}
                <span className={isWith ? "font-semibold" : "text-ink"} data-id="element-57" data-mp="1nhjg2e8iw853">{isWith ? good : bad}</span>
              </li>)}
          </motion.ul>
        </AnimatePresence>
        {!isWith && <button type="button" onClick={() => setMode("with")} className="mt-3 w-full text-center text-sm font-bold text-chalk" data-id="element-58" data-mp="1di2arxx6nw9n">
            Tocá para ver cómo cambia tu semana →
          </button>}
      </div>

      {/* Desktop: table */}
      <div className="mt-10 hidden overflow-hidden rounded-2xl ring-1 ring-line md:block" data-id="element-59" data-mp="21kcrtdxtlkw">
        <table className="w-full text-left" data-id="element-60" data-mp="3tcccjl7pdq6z">
          <thead data-id="element-61" data-mp="28syscrv68hbn">
            <tr data-id="element-62" data-mp="28tibgbwk5br9">
              <th scope="col" className="w-1/2 bg-coral-soft px-6 py-4 text-sm font-bold text-coral" data-id="element-63" data-mp="28ts09w5v9cvd">{costComparison.without}</th>
              <th scope="col" className="w-1/2 bg-chalk px-6 py-4 text-sm font-bold text-white" data-id="element-64" data-mp="2iqd8srh3h63y">{costComparison.with}</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-line bg-card" data-id="element-65" data-mp="2nhv9def7h4oe">
            {costComparison.rows.map(([bad, good]) => <tr key={bad} data-id="element-66" data-mp="2sfwtm2odba1g">
                <td className="px-6 py-4 align-top text-muted" data-id="element-67" data-mp="2whrrex73b5ah">
                  <span className="flex gap-2" data-id="element-68" data-mp="2wfykdgskej1y"><XIcon className="mt-1 h-4 w-4 shrink-0 text-coral" aria-hidden="true" data-id="element-69" data-mp="31guz6pegfpm5" />{bad}</span>
                </td>
                <td className="bg-chalk-soft/50 px-6 py-4 align-top font-semibold" data-id="element-70" data-mp="36gha2s6t8trs">
                  <span className="flex gap-2" data-id="element-71" data-mp="1733fsy6bprdi"><CheckIcon className="mt-1 h-4 w-4 shrink-0 text-chalk" aria-hidden="true" data-id="element-72" data-mp="173vcydfkjx5w" />{good}</span>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </section>;
}